module.exports = __webpack_public_path__ + "static/europeanBannerSwiss-Map-Tablet-71dad834764b49dee026aba481222044.png";